import {
  Directive,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { debounceTime, Subject, Subscription } from 'rxjs';

@Directive({
  selector: '[appInputChangeDebounce]',
})
export class InputChangeDebounceDirective implements OnDestroy {
  @Output() debounceEvent = new EventEmitter<any>();

  private subject = new Subject<any>();
  private debounceSubscription = new Subscription();

  constructor() {
    this.debounceSubscription = this.subject
      .pipe(debounceTime(1000))
      .subscribe((value) => {
        this.debounceEvent.emit(value);
      });
  }
  ngOnDestroy(): void {
    this.debounceSubscription ? this.debounceSubscription.unsubscribe() : null;
  }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    this.subject.next((<HTMLInputElement>event.target).value);
  }
}
